/* import __COLOCATED_TEMPLATE__ from './manual-start-time-entry-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ManualStartTimeComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked startTime = "";
	
	@action
	async enterStartTimeNow()
	{
		const response = await this.ajax.request("/events/"+this.args.event.id+"/enterStartTime");
		
		if(response.error != null)
			alert(response.error);
	}
	
	@action
	async enterStartTime(browserEvent)
	{
		browserEvent.preventDefault();

		var time = new Date(this.startTime);

		if(isNaN(time.getTime()))
		{
			alert('Invalid time format. Please enter a valid date/time.');
			return;
		}

		const impulse = this.store.createRecord('TimingImpulse',
		{
			time: time,
		});

		impulse.EventId = this.args.event;

		await impulse.save();

		var iTR = this.store.createRecord('StartTimingRecord',
		{
		});
		iTR.startImpulseId = impulse;
		iTR.EventId = this.args.event;

		await iTR.save();
	}
}
